<ng-container>
    <div class="flex flex-wrap gap-1" [class.p-1]="row.type !== 'group'">
        <ng-container>
            <ng-container *ngFor="let item of items">
                <ng-container *ngIf="row.type !== 'group'; else groupCell">
                    <fui-badge
                        [title]="
                            (item.list_view_tree_as_folder && item.path_name ? item.path_name + ' / ' : '') + item.name
                        "
                        [image]="getIcon(item)"
                        [color]="getColor(item)"
                        [useBorder]="true"
                        [useBackground]="true"
                    ></fui-badge>
                </ng-container>

                <!-- Шаблон поля группировки -->
                <ng-template #groupCell>
                    <fui-icon *ngIf="getIcon(item) !== null" [icon]="getIcon(item)"></fui-icon>
                    {{
                        (item.list_view_tree_as_folder && item.path_name ? item.path_name + ' / ' : '') + item.name
                            | stripHtml
                    }}
                </ng-template>
            </ng-container>
        </ng-container>
    </div>
</ng-container>
